'use client'

import { ChevronStart } from '@/components/icons/Chevron'
import { MarkdownContent } from '@/components/MarkdownContent'
import { useTranslation } from '@/contexts/I18nContext'
import { useNotificationDetail } from '../hooks/useNotificationDetail'
import { notificationText } from './styles'

const SCROLL_CLASS =
  'mt-[12px] min-h-0 flex-1 overflow-y-auto scrollbar-hide [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'

type Props = {
  notificationId: string
  onBack: () => void
}

export function NotificationDetailPanel({ notificationId, onBack }: Props) {
  const { t } = useTranslation('message')
  const { detailMd, loading } = useNotificationDetail(notificationId)

  return (
    <>
      <header className="flex shrink-0 items-center">
        <button
          type="button"
          className={`flex size-[24px] items-center justify-center ${notificationText.primary}`}
          aria-label={t('Message.Back')}
          onClick={onBack}
        >
          <ChevronStart className="size-[24px]" />
        </button>
      </header>

      <div className={SCROLL_CLASS}>
        {loading ? (
          <div className="flex h-[220px] items-center justify-center">
            <div className="size-[24px] animate-spin rounded-full border-2 border-white/20 border-t-white" />
          </div>
        ) : detailMd ? (
          <MarkdownContent
            content={detailMd}
            className={`text-[14px] leading-[1.7] ${notificationText.primary}`}
            unwrapCodeFences
          />
        ) : (
          <p className={`pt-[80px] text-center text-[14px] ${notificationText.disabled}`}>
            {t('Message.Notification.NotFound')}
          </p>
        )}
      </div>
    </>
  )
}
